import { CoreIcon } from '../core-icon';
import appGoogleplaySVG from '../../assets/logos/app-googleplay.svg';
import type { IconProps } from '../core-icon';

export const AppGoogleplayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={appGoogleplaySVG} {...props} />;
};
